import store from 'app/store/store'
import firebase from 'firebase/app'
import { useEffect, useState } from 'react'
import {
  accessLevelSelector,
  currentItemIdSelector
} from 'app/store/selectors/accessSelectors'
import { shareIdSelector } from 'app/store/selectors/selectors'
import { storeShare } from 'app/store/actions/share'
import { anonSelector } from 'app/store/selectors/baseSelectors'
import { acceptShare as acceptShareUrl } from 'variables'

const useStore = selector => {
  const [state, setState] = useState()
  useEffect(
    store.subscribe(() => {
      setState(selector(store.getState()))
    }),
    [store]
  )
  return state
}

const acceptShare = async data => {
  const token = await firebase.auth().currentUser.getIdToken()
  return fetch(acceptShareUrl, {
    headers: {
      // Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token
    },
    method: 'post',
    body: JSON.stringify({ data })
  })
}

export const useShareAccept = () => {
  const accessLevel = useStore(accessLevelSelector)
  const anon = useStore(anonSelector)
  const currentItemId = useStore(currentItemIdSelector)
  const share = useStore(shareIdSelector)
  const itemId = share ? share.itemId : currentItemId
  const shareId = share ? share.id : 'open'

  const [state, setState] = useState({ loaded: false })

  useEffect(() => {
    // still loading
    if (accessLevel === undefined) return

    // no item ID means we aren't trying to load a board or folder
    if (!itemId) {
      setState({ loaded: true })
      return
    }

    // already have access - loaded
    if (accessLevel) {
      console.log('Has Access')
      setState({
        loaded: true,
        itemId
      })
    }

    // if no access or have a specific share key
    if (!accessLevel || shareId !== 'open') {
      console.time('Accept Share')
      acceptShare({
        itemId: itemId,
        shareId: shareId
      })
        .then(r => r.json())
        .then(result => {
          console.timeEnd('Accept Share')

          if (result.error) {
            console.error(result.error)
            setState({
              loaded: true,
              error: result.error
            })
          }

          console.log(result)
          // store share if anon or null
          store.dispatch(storeShare(anon ? { id: shareId, itemId } : null))
        })
    }
  }, [shareId, itemId, accessLevel, anon])
  return state
}

export default useShareAccept
